var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.4,
    height: 43.4,
    viewBox: "0 0 43.4 43.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "M24.518,19.009A5.509,5.509,0,1,1,19.009,13.5,5.509,5.509,0,0,1,24.518,19.009Z",
    transform: "translate(1.191 1.191)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    d: "M35.289,27.209a3.03,3.03,0,0,0,.606,3.342l.11.11a3.675,3.675,0,1,1-5.2,5.2l-.11-.11a3.055,3.055,0,0,0-5.179,2.167v.312a3.673,3.673,0,1,1-7.345,0v-.165a3.03,3.03,0,0,0-1.983-2.773,3.03,3.03,0,0,0-3.342.606l-.11.11a3.675,3.675,0,1,1-5.2-5.2l.11-.11A3.055,3.055,0,0,0,5.485,25.52H5.173a3.673,3.673,0,0,1,0-7.345h.165a3.03,3.03,0,0,0,2.773-1.983A3.03,3.03,0,0,0,7.5,12.849l-.11-.11a3.675,3.675,0,1,1,5.2-5.2l.11.11a3.03,3.03,0,0,0,3.342.606h.147a3.03,3.03,0,0,0,1.836-2.773V5.173a3.673,3.673,0,1,1,7.345,0v.165A3.055,3.055,0,0,0,30.551,7.5l.11-.11a3.675,3.675,0,1,1,5.2,5.2l-.11.11a3.03,3.03,0,0,0-.606,3.342v.147a3.03,3.03,0,0,0,2.773,1.836h.312a3.673,3.673,0,1,1,0,7.345h-.165a3.03,3.03,0,0,0-2.773,1.836Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#3d3d3d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c242840c88803936ef206290749e3462.svg";
export { ForwardRef as ReactComponent };